import { useNavigate, NavigateFunction } from 'react-router-dom';
import { useUserContext } from '../../providers/UserProvider/UserProvider';
import { APP_URLS } from '../../consts/routes';
import { BRANDS } from '../../components/Itv/types';

export const useBrandedNavigate = (): {
  navigateHome: () => void;
  navigate: NavigateFunction;
  registrationUrl: string;
  activeBrand: BRANDS;
} => {
  const navigate = useNavigate();
  const { theme } = useUserContext();

  const navigateHome = (): void => {
    switch (theme) {
      case BRANDS.SPINS:
        navigate(APP_URLS.itv.spins);
        break;
      case BRANDS.BINGO:
        navigate(APP_URLS.itv.bingo);
        break;
      default:
        navigate(APP_URLS.home);
        break;
    }
  };
  const getRegistrationUrl = (): string => {
    switch (theme) {
      case BRANDS.SPINS:
        return APP_URLS.itv.spinsRegistration;
      case BRANDS.BINGO:
        return APP_URLS.itv.bingoRegistration;
      default:
        return APP_URLS.itv.bingoRegistration;
    }
  };
  const registrationUrl = getRegistrationUrl();

  return { navigateHome, navigate, registrationUrl, activeBrand: theme };
};
